import React from 'react'
import Link from 'next/link'
import { AiFillLock } from 'react-icons/ai'
import { Card } from '../Card'
import { Button } from '../Buttons/Button'
import { FlexColumn, FlexRow } from '../Containers'
import { useGetUser } from 'hooks/useGetUser'
import { RouteEnum } from 'enums/RouteEnum'
import styles from './ProToolsNoAccess.module.scss'
import { useRouter } from 'next/router'

const ProToolsNoAccess: React.FC = () => {
  const { data: user } = useGetUser()
  const router = useRouter()

  return (
    <Card>
      <FlexColumn align="normal" gap="1rem">
        <FlexColumn gap="0.5rem">
          <FlexRow className={styles.iconWrapper} justify="center">
            <AiFillLock />
          </FlexRow>

          <FlexRow justify="center">
            <span>
              {(!user && 'You need to login to access this feature.') ||
                (!user.paid_member &&
                  'This feature is not available on your current plan. You need to upgrade to gain access.')}
            </span>
          </FlexRow>
        </FlexColumn>

        <FlexRow justify="center">
          <Link
            href={
              (!user && `${RouteEnum.LOGIN}/?from=${router.pathname}`) ||
              (!user.paid_member &&
                `${RouteEnum.PRICING}/?from=${router.pathname}`)
            }
            passHref
          >

            <Button>
              {(!user && 'Log In') || (!user.paid_member && 'View Plans')}
            </Button>

          </Link>
        </FlexRow>
      </FlexColumn>
    </Card>
  );
}

export default ProToolsNoAccess
